module.exports = __webpack_public_path__ + "static/media/Gaurav Kumar.jpg:Zone.0d5ffe78.Identifier";